import { render, staticRenderFns } from "./TermsServiceCard.vue?vue&type=template&id=0f55a924"
import script from "./TermsServiceCard.vue?vue&type=script&lang=js"
export * from "./TermsServiceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports